(() => {
  const cookie_name = 'yahava_geo_choice';
  let visitor_country_code = null;

  function show_geolocation_popup() {
    const popup = document.querySelector('[data-geolocation-popup]');
    if (!popup || popup.open) return;

    const target_country_code = popup.dataset.countryCode;
    if (!target_country_code || visitor_country_code !== target_country_code) return;

    try {
      const choice_cookie = document.cookie.split(';').find((cookie) => {
        return cookie.trim().startsWith(`${cookie_name}=`);
      });
      if (choice_cookie) return;
    } catch (error) {
      // The popup can still work when cookies are unavailable.
    }

    popup.showModal();
  }

  function remember_choice(popup, choice) {
    const configured_days = Number(popup.dataset.cookieExpirationDays);
    const expiration_days = Number.isFinite(configured_days) && configured_days > 0
      ? configured_days
      : 1;
    const max_age = Math.round(expiration_days * 24 * 60 * 60);
    const secure_attribute = location.protocol === 'https:' ? '; Secure' : '';

    try {
      document.cookie = `${cookie_name}=${choice}; Max-Age=${max_age}; Path=/; SameSite=Lax${secure_attribute}`;
    } catch (error) {
      // The visitor can still choose a destination without cookies.
    }
  }

  document.addEventListener('geolizr.geoData', (event) => {
    const geo_data = event.detail || event;
    if (!geo_data || geo_data.status === false) return;

    visitor_country_code = (geo_data.countryCode || geo_data.country?.code || '').toUpperCase();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', show_geolocation_popup, { once: true });
      return;
    }

    show_geolocation_popup();
  });

  document.addEventListener('click', (event) => {
    const stay_button = event.target.closest('[data-geolocation-stay]');
    if (stay_button) {
      stay_button.closest('[data-geolocation-popup]').close();
      return;
    }

    if (event.target.closest('[data-geolocation-redirect]')) {
      remember_choice(event.target.closest('[data-geolocation-popup]'), 'redirect');
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-geolocation-popup]')) {
      remember_choice(event.target, 'stay');
    }
  }, true);

  document.addEventListener('shopify:section:load', show_geolocation_popup);
})();
